"use client";

import { type EdgeBand, EdgeBandComponent, Typography } from "@tosize/ui";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { getSimpleProductData } from "~/app/[lang]/command/dialogs/import/actions";
import type { ListImportFormType } from "~/app/[lang]/command/dialogs/import/schema";

interface EdgebandInputProps {
	apiUrl: string;
	index: number;
	messages: {
		label: string;
	};
}

export function EdgebandInput({ apiUrl, index, messages }: EdgebandInputProps) {
	const form = useFormContext<ListImportFormType>();
	const groupedProductId = form.watch("grouped_product_id");
	const simpleProductId = form.watch("simple_product_id");
	const { currentProduct } = getSimpleProductData({ apiUrl, groupedProductId, simpleProductId });
	const [selectedBand, setSelectedBand] = useState<EdgeBand | undefined>();

	if (!currentProduct) {
		return null;
	}

	return (
		<div className="flex flex-col gap-1 sm:col-span-2">
			<Typography variant="paragraph-bold">{messages.label}</Typography>

			<EdgeBandComponent
				className="bg-white"
				size="small"
				sku={currentProduct.sku}
				setSelectedBand={setSelectedBand}
				selectedBand={selectedBand}
				onApplyCallback={(band) => {
					if (band?.thickness) {
						form.setValue(`items.${index}.finishes.thickness`, band.thickness);
						form.setValue(`items.${index}.finishes.sku`, band.sku);
					}
				}}
			/>
		</div>
	);
}
